import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

export interface UnitAwareTagValueEditorProps {
  editorComponent: JSX.Element;
  unitSymbol: string;
}

export default function UnitAwareTagValueEditor({
  editorComponent,
  unitSymbol,
}: UnitAwareTagValueEditorProps): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.editor)}>{editorComponent}</div>
      <span className={css(styles.text)}>{unitSymbol}</span>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  editor: {
    flex: 4,
  },
  text: {
    maxWidth: '20%',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    color: Color.GRAY_600,
  },
});
